import { useEffect, useState } from "react";
import { faSave, faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UnForm from "../../../../../../Form";
import { IConfigGeralVendas } from "../../../../../../../Interfaces/Vendas/ConfigGeral/ConfigGeralInterface";
import Axios from "../../../../../../../Services/Config/API";
import OrSpinner from "../../../../../../Utils/OrSpinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useUserInfor } from "../../../../../../../Context/User";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { ConfigGeralVendasPutController } from "../../../../../../../Controllers/Vendas/ConfigGeral/ConfigGeralService";

export default function VendasConfig() {
    const [selectOptions, setSelectOptions] = useState<{
        [key: string]: Array<{ ID: string; DS: string }>;
    }>({});

    const [loading, setLoading] = useState(false);

    const {
        getConfigGeralVendas,
        getConfigGeralVendasLoading,
        getConfigGeralVendasExec,
    } = useUserInfor();

    const configAgrupada = getConfigGeralVendas?.reduce((acc, curr) => {
        if (!acc[curr.DS_CATEGORIA_CONFIGURACAO]) {
            acc[curr.DS_CATEGORIA_CONFIGURACAO] = [];
        }
        acc[curr.DS_CATEGORIA_CONFIGURACAO].push(curr);
        return acc;
    }, {} as Record<string, IConfigGeralVendas[]>);

    useEffect(() => {
        if (getConfigGeralVendas) {
            setLoading(true); 
    
            const totalRequests = getConfigGeralVendas.length;
            let completedRequests = 0;
    
            getConfigGeralVendas.forEach((config, index) => {
                if (config.DS_TIPO_CAMPO === "LISTA" && config.DS_ENDPOINT) {
                    Axios.get(config.DS_ENDPOINT).then((response) => {
                        const formattedOptions = response.data.map((item: any) => ({
                            ID: item[config.DS_ID_CAMPO],
                            DS: item[config.DS_VALOR_CAMPO],
                        }));
    
                        setSelectOptions((prevState) => ({
                            ...prevState,
                            [config.ID_CONFIG_GERAL_VENDAS]: formattedOptions,
                        }));
                    }).finally(() => {
                        completedRequests += 1;
                        if (completedRequests === totalRequests) {
                            setLoading(false); 
                        }
                    });
                } else {
                    completedRequests += 1;
                    if (completedRequests === totalRequests) {
                        setLoading(false); 
                    }
                }
            });
        }
    }, [getConfigGeralVendas]);
    

    const renderConfigInput = (config: IConfigGeralVendas, index: number) => {
        const configFieldName = `VL_CONFIGURACAO_${config.ID_CONFIG_GERAL_VENDAS}`;

        switch (config.DS_TIPO_CAMPO) {
            case "NUMBER":
                return (
                    <UnForm.Input
                        name={configFieldName}
                        defaultValue={config.VL_CONFIGURACAO}
                        className="mr-2"
                        wrapperClassName="d-flex"
                        type="number"
                    />
                );
            case "BIT":
                return (
                    <UnForm.Select
                        name={configFieldName}
                        defaultValue={config.VL_CONFIGURACAO}
                        className="mr-2"
                        wrapperClassName="d-flex"
                    >
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </UnForm.Select>
                );
            case "LISTA":
                return (
                    <UnForm.Select
                        name={configFieldName}
                        defaultValue={Number(config.VL_CONFIGURACAO)}
                        className="mr-2"
                        wrapperClassName="d-flex"
                    >
                        <option></option>
                        {selectOptions[config.ID_CONFIG_GERAL_VENDAS]?.map(
                            (option, index) => (
                                <option key={index} value={option.ID}>
                                    {option.DS}
                                </option>
                            )
                        )}
                    </UnForm.Select>
                );
            default:
                return (
                    <UnForm.Input
                        name={configFieldName}
                        defaultValue={config.VL_CONFIGURACAO}
                        className="mr-2"
                        wrapperClassName="d-flex"
                    />
                );
        }
    };

    const {
        execute: ConfigGeralVendasPut,
        loading: ConfigGeralVendasPutLoading,
    } = useAsyncCallback(ConfigGeralVendasPutController);

    function handleSubmit(formData: Record<string, any>) {
        const formattedData = Object.keys(configAgrupada ?? []).reduce(
            (acc, category) => {
                configAgrupada?.[category].forEach((config) => {
                    const configObject = {
                        ID_CONFIG_GERAL_VENDAS: config.ID_CONFIG_GERAL_VENDAS,
                        DS_CONFIGURACAO: config.DS_CONFIGURACAO,
                        VL_CONFIGURACAO:
                            formData[
                                `VL_CONFIGURACAO_${config.ID_CONFIG_GERAL_VENDAS}`
                            ],
                        VL_ITEM_CONFIGURACAO:
                            formData[
                                `VL_ITEM_CONFIGURACAO_${config.ID_CONFIG_GERAL_VENDAS}`
                            ],
                        DS_CATEGORIA_CONFIGURACAO:
                            config.DS_CATEGORIA_CONFIGURACAO,
                    };

                    acc.push(configObject);
                });
                return acc;
            },
            [] as any[]
        );

        ConfigGeralVendasPut(formattedData).then((response) => {
            if (getConfigGeralVendasExec) getConfigGeralVendasExec();
        });
    }

    return (
        <OrSpinner loading={getConfigGeralVendasLoading || loading} spinner="capys">
            <UnForm handleSubmit={handleSubmit} className="py-3">
                <div className="col-12 p-0">
                    <div className="d-flex justify-content-end">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="config-vendas-tooltip">
                                    Salvar Configurações
                                </Tooltip>
                            }
                        >
                            <UnForm.SubmitButton
                                color="success"
                                icon={faSave}
                                wrapperClassName="mb-4"
                                loading={ConfigGeralVendasPutLoading}
                                loadingSize="sm"
                                disabled={ConfigGeralVendasPutLoading}
                            ></UnForm.SubmitButton>
                        </OverlayTrigger>
                    </div>
                </div>
                {Object.keys(configAgrupada ?? []).map((category, index) => (
                    <div className="card card-custom p-6 mb-4" key={index}>
                        <h3>
                            <FontAwesomeIcon icon={faWrench} /> {category}
                        </h3>
                        {configAgrupada?.[category]?.map((config, index) => (
                            <div className="my-3 row" key={index}>
                                <div className="col-sm-3 d-flex align-items-center">
                                    <label className="col-form-label">
                                        {config.DS_OBSERVACAO}
                                    </label>
                                </div>
                                <div className="col-sm-9">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <label className="mb-0">
                                                Valor Configuração
                                            </label>
                                            {renderConfigInput(config, index)}
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="mb-0">
                                                Item Configuração
                                            </label>
                                            <UnForm.Input
                                                name={`VL_ITEM_CONFIGURACAO_${config.ID_CONFIG_GERAL_VENDAS}`}
                                                defaultValue={
                                                    config.VL_ITEM_CONFIGURACAO
                                                }
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </UnForm>
        </OrSpinner>
    );
}
